module.exports = __webpack_public_path__ + "static/img/dn5.8259b71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dn5.png
// module id = Z6fD
// module chunks = 0